var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExclamationIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 13.6666C3.31816 13.6666 0.333496 10.6819 0.333496 6.99992C0.333496 3.31792 3.31816 0.333252 7.00016 0.333252C10.6822 0.333252 13.6668 3.31792 13.6668 6.99992C13.6668 10.6819 10.6822 13.6666 7.00016 13.6666ZM6.8335 8.99992C6.55735 8.99992 6.3335 9.22378 6.3335 9.49992V9.83325C6.3335 10.1094 6.55735 10.3333 6.8335 10.3333H7.16683C7.44297 10.3333 7.66683 10.1094 7.66683 9.83325V9.49992C7.66683 9.22378 7.44297 8.99992 7.16683 8.99992H6.8335ZM6.8335 3.66659C6.55735 3.66659 6.3335 3.89044 6.3335 4.16659V7.16659C6.3335 7.44273 6.55735 7.66659 6.8335 7.66659H7.16683C7.44297 7.66659 7.66683 7.44273 7.66683 7.16659V4.16659C7.66683 3.89044 7.44297 3.66659 7.16683 3.66659H6.8335Z",
    fill: "#AFBDCA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExclamationIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exclamationIcon.7e58821a.svg";
export { ForwardRef as ReactComponent };